<div class="row justify-content-center">

  <div class="col-md-6">
    <form class="d-inline-block">
      <div class="row">
        <div class="col-md-9">
          <input type="text" autocomplete="off" class="form-control" [(ngModel)]="contactCenterService.idNumber"
                 name="keyword" placeholder="Search">
        </div>
        <div class="col-md-3">
          <button type="button" class="btn btn-primary btn-circle btn-xl" (click)="search()">
            <i class="fa fa-arrow-right"></i>
          </button>
        </div>
      </div>
      <p class="text-muted">Search by id number.</p>
    </form>
  </div>

</div>


<div class="row justify-content-center">
  <div class="col-12">
    <div class="table-responsive" style="overflow-x: auto;">
      <table class="table table-borderless text-start mt-4 table-hover" style="table-layout: fixed; width: 100%; min-width: 1050px;">
        <thead>
          <tr style="font-size: 0.82rem;">
            <th style="width: 120px;">ID Number</th>
            <th style="width: 130px; white-space: nowrap;">First name</th>
            <th style="width: 110px; white-space: nowrap;">Surname</th>
            <th style="width: 220px;">Email</th>
            <th style="width: 110px;">Current Status</th>
            <th style="width: 110px;">Requested Status</th>
            <th style="width: 90px;">Status</th>
            <th style="width: 160px; text-align: center;">Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let disabilityChangeRequest of results?.content">
            <td (click)="open(disabilityChangeRequest)">{{disabilityChangeRequest?.application.user?.idNumber}}</td>
            <td (click)="open(disabilityChangeRequest)">{{disabilityChangeRequest?.application.user?.firstName}}</td>
            <td (click)="open(disabilityChangeRequest)">{{disabilityChangeRequest?.application.user?.lastName}}</td>
            <td (click)="open(disabilityChangeRequest)" style="word-break: break-all; font-size: 0.85rem;">
              {{disabilityChangeRequest?.application.user?.email}}
            </td>
            <td (click)="open(disabilityChangeRequest)">{{disabilityChangeRequest?.application?.disabled==true ? 'Yes' : 'No'}}</td>
            <td (click)="open(disabilityChangeRequest)">{{disabilityChangeRequest?.to ? 'Yes' : 'No'}}</td>
            <td>{{disabilityChangeRequest.status}}</td>
            <td style="text-align: center; white-space: nowrap;">
              <button *ngIf="disabilityChangeRequest.status ==='Requested'" type="button" class="btn btn-sm btn-outline-dark me-1" (click)="reject(disabilityChangeRequest)">Reject</button>
              <button *ngIf="disabilityChangeRequest.status ==='Requested'" type="button" class="btn btn-sm btn-primary" (click)="confirm(disabilityChangeRequest)">Approve</button>
            </td>
          </tr>
        </tbody>

        <tfoot *ngIf="results.totalElements > 0">
          <tr>
            <td colspan="4">
              <div class="dataTables_info" id="dynamic-table_info" role="status" aria-live="polite">
                Showing {{((currentPage - 1) * perPage) + 1}} to {{results.numberOfElements * currentPage}} of
                {{results.totalElements}} entries
              </div>
            </td>
            <td colspan="4" class="text-end">
              <ngb-pagination [collectionSize]="results.totalElements"
                              [pageSize]="perPage"
                              [(page)]="currentPage"
                              [maxSize]="10"
                              [rotate]="true"
                              (pageChange)="search()"></ngb-pagination>
            </td>
          </tr>
        </tfoot>

      </table>
    </div>
  </div>
</div>


